import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { SubscriptionDataType } from './TypePromise';
import { defaultHeaders } from '@redux/api/Config';
import config from '@app/config';

export const subscriptionApi = createApi({
  reducerPath: 'subscriptionApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.baseApiUrl,
    prepareHeaders: defaultHeaders,
  }),
  endpoints: builder => ({
    getPrice: builder.query<SubscriptionDataType, { rn: number; regionSlug: string }>({
      query: ({ rn, regionSlug }) => `/api/subscription/getPriceAndUrlSubscription?productRN=${rn}&regionSlug=${regionSlug}`,
      transformResponse: (response: { data }): SubscriptionDataType => response.data,
    }),
  }),
});

export const { useGetPriceQuery } = subscriptionApi;
